import React, { useEffect, useState } from "react";
import { TextField, Button,Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

const NameEditDialog = (({ open, currentName, onClose, onSave }) => {
    const [name, setName] = useState(currentName);
  
    useEffect(() => {
      setName(currentName);
    }, [currentName]);
  
    const handleSave = () => {
      if (name.trim()) {
        onSave(name.trim());
      }
    };
  
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontSize: '18px', fontWeight: 500, color: '#3B4A54' }}>
          Edit Contact Name
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Contact Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSave()}
            margin="dense"
            variant="outlined"
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} sx={{ color: '#667781', textTransform: 'none' }}>
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" sx={{ 
            backgroundColor: '#00A884', 
            textTransform: 'none',
            '&:hover': { backgroundColor: '#008F72' }
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
});

export default NameEditDialog;